{
  "market": {
    "common": {
      "conditions": {
        "new": "Nuevo",
        "used": "Usado",
        "refurbished": "Reacondicionado"
      },
      "status": {
        "draft": "Borrador",
        "published": "Publicada",
        "publishedProduct": "Publicado",
        "disabled": "Desactivada",
        "disabledProduct": "Desactivado",
        "archived": "Archivada",
        "archivedProduct": "Archivado"
      },
      "sessionExpired": "Sesión caducada.",
      "sessionExpiredReconnect": "Sesión caducada — vuelve a iniciar sesión.",
      "sessionExpiredReconnect2": "Sesión caducada. Vuelve a iniciar sesión.",
      "networkError": "Problema de conexión. Inténtalo de nuevo.",
      "cannotLoad": "No se puede cargar.",
      "retry": "Reintentar",
      "loading": "Cargando…",
      "back": "Volver",
      "cancel": "Cancelar",
      "save": "Guardar",
      "saving": "Guardando…",
      "copy": "Copiar enlace",
      "copied": "¡Copiado!",
      "seeMore": "Ver más",
      "offlineText": "Sin conexión a internet"
    },
    "boutiques": {
      "searchPlaceholder": "Buscar…",
      "headerCount_one": "{{count}} tienda",
      "headerCount_other": "{{count}} tiendas",
      "loadingNormal": "Buscando las mejores tiendas…",
      "loadingSearch": "Buscando…",
      "errorNormal": "No se pueden cargar las tiendas en este momento.",
      "errorSearch": "No se pudo iniciar la búsqueda.",
      "emptyNormal": "Aún no hay tiendas publicadas.",
      "emptySearch": "Ninguna tienda coincide con esta búsqueda.",
      "online": "En línea",
      "productsCount_one": "{{count}} producto",
      "productsCount_other": "{{count}} productos",
      "subscribersCount_one": "{{count}} suscriptor",
      "subscribersCount_other": "{{count}} suscriptores",
      "visit": "Visitar"
    },
    "creerBoutique": {
      "headerTitle": "Nueva tienda",
      "subtitle": "Ponle un nombre a tu tienda. Podrás personalizar su apariencia y añadir productos justo después.",
      "nameLabel": "Nombre de la tienda",
      "namePlaceholder": "Ej.: Taller Wax & Co",
      "submit": "Crear tienda"
    },
    "creerProduit": {
      "headerTitle": "Nuevo producto",
      "createButton": "Crear",
      "intro": "Completa la ficha de tu producto ahora. Los campos marcados con un asterisco son obligatorios — el resto se puede completar o modificar más tarde.",
      "sections": {
        "essential": "Esencial",
        "details": "Detalles",
        "advanced": "Opciones avanzadas",
        "advancedSubtitle": "Precio de oferta, moneda, destacado, botones de acción",
        "seo": "SEO",
        "seoSubtitle": "Cómo aparece este producto en los resultados de búsqueda y al compartirlo"
      },
      "fields": {
        "nameLabel": "Nombre del producto *",
        "namePlaceholder": "Ej.: Collar de cuentas wax",
        "priceLabel": "Precio ({{currency}}) *",
        "pricePlaceholder": "Ej.: 8000",
        "categoryLabel": "Categoría",
        "categoryPlaceholder": "Déjalo en blanco para «Otro»",
        "categoryHint": "Identificador de la categoría — pronto un selector reemplazará este campo.",
        "descriptionShortLabel": "Descripción corta",
        "descriptionShortPlaceholder": "Una frase que dé ganas de comprarlo",
        "descriptionLabel": "Descripción completa",
        "descriptionPlaceholder": "Detalla las características, materiales, dimensiones…",
        "brandLabel": "Marca",
        "brandPlaceholder": "Ej.: Hecho a mano, Nike…",
        "conditionLabel": "Estado",
        "stockLabel": "Stock disponible",
        "stockPlaceholder": "Ej.: 12",
        "stockHint": "Déjalo en blanco para empezar en 0.",
        "skuLabel": "Referencia (SKU)",
        "skuPlaceholder": "Ej.: COL-WAX-001",
        "skuHint": "Debe ser único dentro de esta tienda si se especifica.",
        "promoPriceLabel": "Precio promocional",
        "promoPricePlaceholder": "Debe ser menor o igual al precio normal",
        "currencyLabel": "Moneda",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Código ISO de 3 letras (XOF, EUR, USD…).",
        "featuredLabel": "Destacar este producto",
        "seoTitleLabel": "Título SEO",
        "seoTitlePlaceholder": "Título mostrado en los resultados de búsqueda",
        "seoDescriptionLabel": "Descripción SEO",
        "seoDescriptionPlaceholder": "Resumen mostrado debajo del título en las búsquedas"
      },
      "actionButtons": {
        "groupLabel": "Botones de acción",
        "whatsapp": "Botón de WhatsApp dedicado",
        "whatsappField": "Número de WhatsApp mostrado solo para este producto",
        "whatsappPlaceholder": "Ej.: +225 07 00 00 00 00",
        "buy": "Botón «Comprar»",
        "buyField": "Enlace a la página o al pago",
        "learnMore": "Botón «Saber más»",
        "learnMoreField": "Enlace a más detalles",
        "call": "Botón «Llamar»",
        "callField": "Número al que llamar para este producto"
      },
      "preview": {
        "label": "Vista previa",
        "namePlaceholder": "Nombre del producto",
        "promoLabel": "Precio de oferta: {{price}}",
        "featuredBadge": "Destacado",
        "hint": "La foto, el ambiente y el diseño real estarán disponibles justo después de la creación."
      }
    },
    "index": {
      "searchPlaceholder": "Buscar…",
      "headerCount_one": "{{count}} producto",
      "headerCount_other": "{{count}} productos",
      "loadingNormal": "Cargando el mercado…",
      "loadingSearch": "Buscando…",
      "errorNormal": "No se puede cargar el mercado.",
      "errorSearch": "No se pudo iniciar la búsqueda.",
      "emptyNormal": "Aún no hay productos publicados.",
      "emptySearch": "Ningún producto coincide con esta búsqueda.",
      "newBadge": "Nuevo",
      "whatsapp": "WhatsApp",
      "contact": "Contactar",
      "contacting": "Abriendo…",
      "buy": "Comprar",
      "learnMore": "Saber más",
      "call": "Llamar",
      "seeMore": "Ver más",
      "goToShop": "Ir a la tienda",
      "whatsappMessage": "Hola, estoy interesado/a en \"{{product}}\" en Harmonia Market."
    },
    "reglages": {
      "headerTitle": "Ajustes",
      "headerSubPro": "Gestiona tus tiendas, favoritos y suscripciones",
      "headerSubStandard": "Tus favoritos y tiendas seguidas",
      "sections": {
        "subscribedShops": "Tiendas suscritas",
        "favorites": "Favoritos",
        "myShops": "Mis tiendas"
      },
      "noSubscribedShops": "Todavía no sigues ninguna tienda.",
      "noFavorites": "Aún no hay productos guardados.",
      "noMyShops": "Todavía no tienes ninguna tienda.",
      "productsCount_one": "{{count}} producto",
      "productsCount_other": "{{count}} productos",
      "createShopButton": "Crear una nueva tienda"
    },
    "gererShop": {
      "notFound": "Tienda no encontrada.",
      "sections": {
        "coverPhoto": "Foto de portada",
        "publicLink": "Enlace público",
        "generalInfo": "Información general",
        "contacts": "Contactos",
        "location": "Ubicación",
        "seo": "SEO",
        "status": "Estado de la tienda",
        "colors": "Colores",
        "typography": "Tipografía, diseño, encabezado",
        "products": "Productos",
        "dangerZone": "Zona de peligro"
      },
      "colorFields": {
        "primary": "Color principal",
        "secondary": "Color secundario",
        "accent": "Color de acento",
        "background": "Color de fondo",
        "card": "Color de las tarjetas",
        "button": "Color de los botones",
        "border": "Color de los bordes",
        "text": "Color del texto",
        "link": "Color de los enlaces"
      },
      "publicLinkHint": "Esta página es visible para todo el mundo, incluidas las personas que no han iniciado sesión. Comparte este enlace para dar a conocer tu tienda.",
      "publicLinkPending": "El enlace estará disponible una vez que se guarde la tienda.",
      "saveError": "Error al guardar — inténtalo de nuevo.",
      "fields": {
        "taglineLabel": "Eslogan",
        "taglinePlaceholder": "Una frase que resuma tu tienda",
        "taglineHint": "Máx. 160 caracteres.",
        "descriptionLabel": "Descripción",
        "descriptionPlaceholder": "Presenta tu tienda en detalle",
        "whatsappLabel": "Número de WhatsApp Business",
        "whatsappPlaceholder": "Ej.: +225 07 00 00 00 00",
        "whatsappHint": "Necesario si el botón de WhatsApp está activado abajo.",
        "showWhatsappBtn": "Mostrar el botón de WhatsApp",
        "showChatBtn": "Mostrar el chat de la plataforma",
        "contactEmailLabel": "Correo de contacto",
        "contactEmailPlaceholder": "contacto@mitienda.com",
        "contactPhoneLabel": "Teléfono de contacto",
        "contactPhonePlaceholder": "Ej.: +225 07 00 00 00 00",
        "countryLabel": "País",
        "countryPlaceholder": "Ej.: Costa de Marfil",
        "cityLabel": "Ciudad",
        "cityPlaceholder": "Ej.: Abiyán",
        "addressLabel": "Dirección",
        "addressPlaceholder": "Dirección completa",
        "currencyLabel": "Moneda",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Código ISO de 3 letras en mayúsculas (XOF, EUR, USD…).",
        "languageLabel": "Idioma",
        "timezoneLabel": "Zona horaria",
        "timezonePlaceholder": "Ej.: Africa/Abidjan",
        "seoTitleLabel": "Título SEO",
        "seoTitlePlaceholder": "Título mostrado en los resultados de búsqueda",
        "seoDescriptionLabel": "Descripción SEO",
        "seoDescriptionPlaceholder": "Resumen mostrado debajo del título en las búsquedas"
      },
      "statusHint": "Una tienda «Publicada» es visible públicamente, incluso para personas que no han iniciado sesión.",
      "typographyPending": "Estos ajustes llegarán en una próxima actualización.",
      "noProducts": "Aún no hay productos.",
      "cannotLoadProducts": "No se pudieron cargar los productos.",
      "createProductButton": "Crear un producto",
      "dangerTitle": "Eliminar esta tienda",
      "dangerText": "Esta acción es definitiva. Todos los productos de esta tienda se eliminarán junto con ella.",
      "dangerButton": "Eliminar la tienda",
      "deleteModal": {
        "title": "¿Eliminar «{{name}}»?",
        "text": "Esta acción es irreversible. Todos los productos de esta tienda ({{count}}) se eliminarán definitivamente junto con ella.",
        "confirmLabel": "Para confirmar, escribe el nombre exacto de la tienda:",
        "confirmButton": "Eliminar definitivamente"
      }
    },
    "gererProduit": {
      "notFound": "Producto no encontrado.",
      "saveButton": "Guardar",
      "savedBanner": "Cambios guardados",
      "saveError": "Error al guardar — inténtalo de nuevo.",
      "sections": {
        "publicLink": "Enlace público",
        "photos": "Fotos",
        "essential": "Esencial",
        "details": "Detalles",
        "advanced": "Opciones avanzadas",
        "seo": "SEO",
        "dangerZone": "Zona de peligro"
      },
      "publicLinkHint": "Esta página es visible para todo el mundo, incluidas las personas que no han iniciado sesión. Comparte este enlace para dar a conocer este producto.",
      "publicLinkPending": "El enlace estará disponible una vez que se guarde el producto.",
      "fields": {
        "mainPhoto": "Foto principal",
        "photo2": "Foto 2",
        "photo3": "Foto 3",
        "photo3Hint": "La foto 3 requiere que la foto 2 ya esté configurada.",
        "nameLabel": "Nombre del producto *",
        "namePlaceholder": "Ej.: Collar de cuentas wax",
        "priceLabel": "Precio ({{currency}}) *",
        "pricePlaceholder": "Ej.: 8000",
        "categoryLabel": "Categoría",
        "statusLabel": "Estado",
        "descriptionShortLabel": "Descripción corta",
        "descriptionShortPlaceholder": "Una frase que dé ganas de comprarlo",
        "descriptionLabel": "Descripción completa",
        "descriptionPlaceholder": "Detalla las características…",
        "brandLabel": "Marca",
        "brandPlaceholder": "Ej.: Hecho a mano, Nike…",
        "conditionLabel": "Estado",
        "stockLabel": "Stock disponible",
        "stockPlaceholder": "Ej.: 12",
        "promoPriceLabel": "Precio promocional",
        "promoPricePlaceholder": "Debe ser ≤ al precio normal",
        "currencyLabel": "Moneda",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Código ISO de 3 letras.",
        "featuredLabel": "Destacar este producto",
        "showChatLabel": "Mostrar el chat de la plataforma",
        "seoTitleLabel": "Título SEO",
        "seoTitlePlaceholder": "Título mostrado en los resultados de búsqueda",
        "seoDescriptionLabel": "Descripción SEO",
        "seoDescriptionPlaceholder": "Resumen mostrado debajo del título"
      },
      "actionButtons": {
        "groupLabel": "Botones de acción",
        "whatsapp": "Botón de WhatsApp dedicado",
        "whatsappHint": "Número específico para este producto.",
        "whatsappPlaceholder": "Ej.: +225 07 00 00 00 00",
        "buy": "Botón «Comprar»",
        "learnMore": "Botón «Saber más»",
        "call": "Botón «Llamar»",
        "callPlaceholder": "Ej.: +225 07 00 00 00 00"
      },
      "dangerTitle": "Eliminar este producto",
      "dangerText": "Esta acción es definitiva y no se puede deshacer.",
      "dangerButton": "Eliminar el producto",
      "deleteModal": {
        "title": "¿Eliminar «{{name}}»?",
        "text": "Esta acción es irreversible.",
        "confirmButton": "Eliminar"
      }
    },
    "components": {
      "categoryChips": {
        "loading": "Cargando categorías…",
        "error": "No se pudieron cargar las categorías.",
        "allLabel": "Todas"
      },
      "colorPicker": {
        "cancel": "Cancelar",
        "confirm": "Confirmar"
      },
      "detailProduit": {
        "newBadge": "Nuevo",
        "inStock": "En stock ({{count}})",
        "outOfStock": "Agotado",
        "descriptionTitle": "Descripción",
        "whatsapp": "Contactar por WhatsApp",
        "contactSeller": "Contactar al vendedor",
        "contacting": "Abriendo…",
        "buy": "Comprar",
        "learnMore": "Saber más",
        "call": "Llamar",
        "goToShop": "Ir a la tienda",
        "whatsappMessage": "Hola, estoy interesado/a en \"{{product}}\" en Harmonia Market."
      },
      "searchBar": {
        "placeholder": "Buscar…"
      },
      "shopHeader": {
        "productsLabel": "Productos",
        "subscribersLabel": "Suscriptores",
        "subscribed": "Suscrito",
        "subscribe": "Suscribirse",
        "subscribing": "…"
      },
      "imagePicker": {
        "change": "Cambiar",
        "add": "Añadir una imagen",
        "sessionExpired": "Sesión caducada.",
        "uploadError": "Error al subir la imagen."
      }
    },
    "produitDetail": {
      "loading": "Cargando el producto…",
      "notFound": "Este producto no existe o ya no está disponible.",
      "cannotLoad": "No se pudo cargar este producto."
    },
    "boutiqueDetail": {
      "loading": "Cargando la tienda…",
      "notFound": "Esta tienda no existe o ya no está disponible.",
      "cannotLoad": "No se pudo cargar esta tienda.",
      "shopNotFound": "Tienda no encontrada.",
      "newBadge": "Nuevo",
      "productsTitle": "Productos",
      "cannotLoadProducts": "No se pudieron cargar los productos.",
      "noProducts": "Aún no hay productos publicados."
    }
  }
}
